import React from "react";
import { Dummyimage1 } from "../../assets/img";

const PropertyDetails = ({ PropertyDetails }) => {
  return (
    <div className="roles-bg rounded-4 col-md-5 mt-0">
      <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
        Property Details
      </h2>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          ID
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {PropertyDetails?.property_code}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Name
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {PropertyDetails?.name}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Location
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {PropertyDetails?.location}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Images
        </p>
        <img
          alt=""
          className="view-img"
          src={PropertyDetails?.image ?? Dummyimage1}
        />
      </div>
    </div>
  );
};

export default PropertyDetails;
